import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchAccounts = async (params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/accounts${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const checkAccountUsername = async (username) => {
  const query = new URLSearchParams();
  if (username) query.append('username', username);
  const response = await fetch(`${API_BASE_URL}/accounts/check-username?${query.toString()}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createAccount = async (data) => {
  const response = await fetch(`${API_BASE_URL}/accounts`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateAccount = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/accounts/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteAccount = async (id) => {
  const response = await fetch(`${API_BASE_URL}/accounts/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const bulkCreateAccounts = async (payload) => {
  const response = await fetch(`${API_BASE_URL}/accounts/bulk`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
};

export const bulkDeleteAccounts = async (ids) => {
  const response = await fetch(`${API_BASE_URL}/accounts/bulk-delete`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ ids })
  });
  return handleResponse(response);
};
